exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product-img-box .ivu-checkbox{position:absolute;z-index:999;left:0;top:0}.productsCont{background-color:#fff;border:1px solid #d7dde4}.flip-list-move{-webkit-transition:-webkit-transform .3s ease-in;transition:-webkit-transform .3s ease-in;transition:transform .3s ease-in;transition:transform .3s ease-in,-webkit-transform .3s ease-in}", ""]);

// exports
